import { useEffect, useRef } from "react";
import "./TestEnvironmentNotice.css";

export default function TestEnvironmentNotice({ isRegistering, onCancel, onAccept }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => dialog.close();
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className="signup-test-notice"
      aria-labelledby="signup-test-notice-title"
      aria-busy={isRegistering}
      onCancel={(event) => {
        event.preventDefault();
        if (!isRegistering) onCancel();
      }}
    >
      <h2 id="signup-test-notice-title" tabIndex={-1} autoFocus>Hinweis zur Testumgebung</h2>
      <p>Sie registrieren sich aktuell in der Testumgebung von GreenOne. Bitte beachten Sie dazu folgende Punkte:</p>
      <p><strong>Testbetrieb:</strong> Die Plattform befindet sich derzeit im Testbetrieb. Nach dem offiziellen Go-Live kann es erforderlich sein, dass Sie Ihre Daten erneut erfassen müssen.</p>
      <p><strong>Funktionsumfang:</strong> Nicht alle Funktionen sind zum heutigen Zeitpunkt verfügbar. GreenOne wird laufend weiterentwickelt und um neue Funktionen ergänzt.</p>
      <p><strong>Berechnungsmodelle:</strong> Die zugrunde liegenden Berechnungsmodelle befinden sich aktuell in der finalen Validierungsphase und können sich allenfalls noch ändern.</p>
      <p><strong>Datenspeicherung:</strong> Die Plattform wird in einer AWS-Cloud-Umgebung im EU-Raum betrieben.</p>
      <p>Mit der Registrierung bestätigen Sie, dass Ihnen diese Punkte bekannt sind und Sie mit der Nutzung der Testumgebung unter diesen Bedingungen einverstanden sind.</p>
      <div className="signup-test-notice-actions">
        <sdx-button type="button" theme="secondary" label="abbrechen" disabled={isRegistering} onClick={() => { if (!isRegistering) onCancel(); }}></sdx-button>
        <sdx-button type="button" theme="primary" label="akzeptieren" disabled={isRegistering} onClick={() => { if (!isRegistering) onAccept(); }}></sdx-button>
      </div>
    </dialog>
  );
}
